<template>
  <div class="attendance-picker flex flex-nowrap items-center gap-2 overflow-auto no-scrollbar scroll">
    <etg-button
      v-for="i in props.options"
      :key="i"
      :type="i === peopleCount ? 'primary' : 'ghost'"
      class="!w-8 !h-8 !p-1.5 !rounded-full flex-none"
      @click="handlePeopleClick(i)"
    >
      {{ i }}
    </etg-button>
  </div>
</template>

<script setup lang="ts">
const peopleCount = defineModel('modelValue', {
  type: Number,
})

const props = withDefaults(
  defineProps<{
    options?: number[]
  }>(),
  {
    options: () => Array.from({ length: 10 }, (_, i) => i + 1),
  }
)

const handlePeopleClick = (count: number) => {
  peopleCount.value = count
}
</script>
